module.exports = __webpack_public_path__ + "static/media/bn-BD.0d9613fc.md";